import React from 'react';
import { FaCamera } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import CollapsibleDocuments from './CollapsibleDocuments';
import EmptyContent from '../../EmptyContent';

function DocumentsTab() {
  const { segments } = useSelector((state) => state?.hotbar);

  // Calculate the total number of valid documents
  const totalDocuments = segments?.reduce((sum, segment) => {
    return sum + (segment?.items?.documents?.filter((doc) => doc?.src !== null).length || 0);
  }, 0);

  return (
    <>
      {totalDocuments > 0 ? (
        segments?.map((segment) =>
          segment?.items?.documents?.length ? (
            <CollapsibleDocuments
              key={segment.title} // Assuming title is unique
              documents={segment.items.documents.filter((doc) => doc?.src !== null)}
              icon={<FaCamera />}
              title={segment.title}
              segmentColor={segment.segmentColor}
            />
          ) : null
        )
      ) : (
        <EmptyContent />
      )}
    </>
  );
}

export default DocumentsTab;
